import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
export var defaultCurrency = Object.freeze({
  code: 'CAD',
  prefix: true,
  sign: '$'
});
export var formatCurrency = function formatCurrency(
//@ts-expect-error TODO: fix this
value) {
  var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultCurrency;
  var useParenthesis = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var isCents = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var appendCode = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var floatValue;
  var strValue;
  var cents;
  var blocks;
  var remaining;

  // determine if isCents is passed in
  if (isCents) {
    floatValue = parseInt(value, 10);
  } else {
    floatValue = parseFloat(value);
  }
  if (isNaN(floatValue)) return null;
  if (isCents) {
    strValue = "00".concat(Math.abs(floatValue));
    cents = strValue.substr(-2);
    var positiveIntPart = "".concat(parseInt(strValue.substr(0, strValue.length - 2), 10));
    blocks = [positiveIntPart.substr(-3)];
    remaining = positiveIntPart.substr(0, positiveIntPart.length - 3);
  } else {
    var positiveFloatValue = Math.abs(floatValue).toFixed(2);
    blocks = [positiveFloatValue.substr(-6)];
    remaining = positiveFloatValue.substr(0, positiveFloatValue.length - 6);
  }
  while (remaining.length > 0) {
    var nextPart = remaining.substr(-3);
    blocks = [nextPart].concat(blocks);
    remaining = remaining.substr(0, remaining.length - 3);
  }
  var number = "".concat(useParenthesis ? '' : '-').concat(blocks.join(','));
  var contents;
  if (isCents) {
    contents = "".concat(number, ".").concat(cents);
  } else {
    contents = "".concat(number);
  }
  if (currency.prefix) {
    contents = "".concat(currency.sign).concat(contents);
  } else {
    contents = "".concat(contents).concat(currency.sign);
  }
  if (appendCode) {
    contents = "".concat(contents, " ").concat(currency.code);
  }
  if (value < 0 && useParenthesis) {
    contents = "(".concat(contents, ")");
  }
  return contents;
};